// extracted by mini-css-extract-plugin
export var wrapperStyle = "blog_article_list_featured-module--wrapperStyle--n4OV4";